export const hasArrayData = (value: any): boolean => Array.isArray(value) && value.length > 0;
export const hasObjectData = (value: any): boolean =>
  value !== null && typeof value === 'object' && Object.keys(value).length > 0;

export const extractReportSummary = (analysis: any): Record<string, unknown> | null => {
  const candidates = [
    analysis?.results?.report_summary,
    analysis?.report_summary,
    analysis?.summary
  ];

  for (const candidate of candidates) {
    if (candidate && typeof candidate === 'object') {
      return candidate as Record<string, unknown>;
    }
  }

  return null;
};

const extractModelResults = (analysis: any, key: 'ml_results' | 'rule_based_results') => {
  const candidates = [analysis?.results?.[key], analysis?.[key]];

  for (const candidate of candidates) {
    if (candidate && typeof candidate === 'object') {
      return candidate;
    }
  }

  return null;
};

export const analysisHasSummaryMetrics = (analysis: any): boolean => {
  const summary = extractReportSummary(analysis);
  if (!summary) {
    return false;
  }

  const metricKeys = [
    'max_probability',
    'average_probability',
    'avg_probability',
    'discovery_probability',
    'peak_probability'
  ];

  return metricKeys.some((key) => typeof (summary as Record<string, unknown>)[key] === 'number');
};

export const analysisHasHeatmapData = (analysis: any): boolean => {
  const mlResults = extractModelResults(analysis, 'ml_results');
  const ruleResults = extractModelResults(analysis, 'rule_based_results');

  if (mlResults && hasArrayData(mlResults.grid_coordinates) && hasArrayData(mlResults.grid_probabilities)) {
    return true;
  }

  if (mlResults && hasArrayData(mlResults.grid_points)) {
    return true;
  }

  if (ruleResults && hasArrayData(ruleResults.grid_coordinates) && hasArrayData(ruleResults.grid_probabilities)) {
    return true;
  }

  if (ruleResults && hasArrayData(ruleResults.grid_points)) {
    return true;
  }

  if (hasArrayData(analysis?.gridCoordinates) && hasArrayData(analysis?.gridProbabilities)) {
    return true;
  }

  if (hasArrayData(analysis?.results?.top_targets) || hasArrayData(analysis?.topTargets)) {
    return true;
  }

  if (hasArrayData(analysis?.highPotentialAreas) || hasArrayData(analysis?.results?.ml_results?.highPotentialAreas)) {
    return true;
  }

  return false;
};

export const analysisHasRasterData = (analysis: any): boolean => {
  const candidates = [
    analysis?.results?.ml_results?.raster_assets,
    analysis?.results?.raster_assets,
    analysis?.ml_results?.raster_assets,
    analysis?.raster_assets
  ];

  return candidates.some(hasObjectData);
};

export const analysisHasDetailedResults = (analysis: any): boolean =>
  analysisHasSummaryMetrics(analysis) && analysisHasHeatmapData(analysis);
